export default {
    "name": "EnteredBy",
    "kind": "HoudiniFragment",
    "hash": "716bb25bd103593f16b5a3130fc5e4c35fd7f4b4c82c2c97d7f6da0c773c3a72",

    "raw": `fragment EnteredBy on Inventory {
  enteredBy {
    id
    name
  }
  id
  __typename
}
`,

    "rootType": "Inventory",
    "stripVariables": [],

    "selection": {
        "fields": {
            "enteredBy": {
                "type": "UserAccount",
                "keyRaw": "enteredBy",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "id": {
                "type": "UInt",
                "keyRaw": "id",
                "visible": true
            },

            "__typename": {
                "type": "String",
                "keyRaw": "__typename",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    }
};

"HoudiniHash=b07cdcf682907e8d3dc5cd0b731b6dc5164bc65f723721f13b819b3ca705fd08";